// store/useModalStore.js
import { create } from 'zustand';

export const useModalStore = create(set => ({
  isOpen: false,
  content: null,
  props: {},

  openModal: (content, props = {}) =>
    set({
      isOpen: true,
      content,
      props,
    }),

  closeModal: () =>
    set({
      isOpen: false,
      content: null,
      props: {},
    }),
}));
